import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared shell for auth screens (Login, Register, Verify OTP, Forgot/Reset).
 * Left column: form. Right column: brand imagery.
 */
export const AuthShell = ({
  eyebrow,
  title,
  subtitle,
  children,
  image = "https://images.unsplash.com/photo-1745761320791-5ae142edee8c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  imageCaption = "Villa Tramonto · Amalfi Coast, Italy",
}) => (
  <main className="mx-auto grid min-h-[calc(100svh-72px)] max-w-[1400px] grid-cols-1 gap-0 md:grid-cols-2">
    <section className="flex flex-col justify-between px-5 py-10 md:px-10 md:py-14">
      <Link
        to="/"
        className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground md:text-xs"
      >
        <ArrowLeft size={12} /> Back to StayEasy
      </Link>

      <div className="max-w-md pt-16 md:pt-0">
        <p className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground md:text-xs">
          {eyebrow}
        </p>
        <h1 className="mt-5 font-display text-4xl font-medium leading-[0.95] tracking-tight md:mt-8 md:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground md:mt-6 md:text-base">
            {subtitle}
          </p>
        )}
        <div className="mt-8 md:mt-10">{children}</div>
      </div>

      <p className="mt-12 text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:text-xs">
        © 2026 StayEasy
      </p>
    </section>

    <aside className="relative hidden overflow-hidden bg-muted md:block">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
      <p className="absolute bottom-8 left-8 text-[10px] uppercase tracking-[0.2em] text-[#F6F4EF]/85 md:text-xs">
        {imageCaption}
      </p>
    </aside>
  </main>
);

export default AuthShell;
